let detected = false
let dismissed = false
const listeners = new Set<() => void>()

const notify = () => listeners.forEach(l => l())

export const versionStore = {
	subscribe: (callback: () => void) => {
		listeners.add(callback)

		return () => listeners.delete(callback)
	},
	getSnapshot: () => detected,
	setDetected: () => {
		if (detected || dismissed) return
		detected = true
		notify()
	},
	dismiss: () => {
		dismissed = true
		if (!detected) return
		detected = false
		notify()
	}
}
